(function () {
  var FAMILY_ORDER = ['silver', 'gold', 'platinum', 'other'];
  var FAMILY_LABEL = { silver: 'Silver', gold: 'Gold', platinum: 'Platinum', other: 'Other' };
  var FAMILY_DOT = { silver: '#C9CDD3', gold: '#D4AF37', platinum: '#E5E4E2', other: '#B0B0B0' };
  var COLOR_ORDER = ['Yellow', 'White', 'Rose'];
  var COLOR_DOT = { Yellow: '#D4AF37', White: '#C9CDD3', Rose: '#E8B4A2' };

  function karatNumber(karat) {
    return parseFloat(karat) || 0;
  }

  function buildDot(className, color) {
    var dot = document.createElement('span');
    dot.className = className;
    dot.style.backgroundColor = color;
    return dot;
  }

  function buildTab(family) {
    var tab = document.createElement('button');
    tab.type = 'button';
    tab.className = 'metal-tab';
    tab.setAttribute('data-metal-tab', family);
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-selected', 'false');

    var dot = buildDot('metal-tab-dot', FAMILY_DOT[family] || FAMILY_DOT.other);

    var label = document.createElement('span');
    label.className = 'metal-tab-label';
    label.textContent = FAMILY_LABEL[family] || family;

    tab.appendChild(dot);
    tab.appendChild(label);
    return tab;
  }

  function setActiveTab(tabs, panels, panelsWrap, family) {
    tabs.forEach(function (t) {
      var isActive = t.getAttribute('data-metal-tab') === family;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var activePanel = null;
    panels.forEach(function (p) {
      var isActive = p.getAttribute('data-metal-panel') === family;
      p.hidden = !isActive;
      if (isActive) activePanel = p;
    });

    // A family with only one value (Silver / Platinum) has nothing to pick --
    // the tab click already selects it -- so the panels card would just show
    // an empty/redundant box. Only show the card when there's an actual
    // choice to make (Gold's color/karat grid).
    var leafCount = activePanel ? activePanel.querySelectorAll('[data-option-value]').length : 0;
    panelsWrap.style.display = leafCount > 1 ? '' : 'none';
  }

  function initItem(item) {
    var source = item.querySelector('[data-metal-source]');
    var mount = item.querySelector('[data-metal-picker]');
    if (!source || !mount) return;

    var leaves = Array.prototype.slice.call(source.querySelectorAll('[data-option-value]'));
    if (leaves.length < 2) return;

    var families = [];
    leaves.forEach(function (btn) {
      var family = btn.getAttribute('data-metal-family') || 'other';
      if (families.indexOf(family) === -1) families.push(family);
    });
    families.sort(function (a, b) {
      return FAMILY_ORDER.indexOf(a) - FAMILY_ORDER.indexOf(b);
    });
    if (families.length < 2) return;

    var initialActive = source.querySelector('[data-option-value].active') || leaves[0];
    var initialFamily = initialActive.getAttribute('data-metal-family') || families[0];

    var tabsWrap = document.createElement('div');
    tabsWrap.className = 'metal-tabs';
    tabsWrap.setAttribute('role', 'tablist');

    var panelsWrap = document.createElement('div');
    panelsWrap.className = 'metal-panels';

    var tabs = [];
    var panels = [];

    families.forEach(function (family) {
      var familyLeaves = leaves.filter(function (btn) {
        return (btn.getAttribute('data-metal-family') || 'other') === family;
      });

      var tab = buildTab(family);
      tabsWrap.appendChild(tab);
      tabs.push(tab);

      var panel = document.createElement('div');
      panel.className = 'metal-panel';
      panel.setAttribute('data-metal-panel', family);
      panel.hidden = family !== initialFamily;

      if (family === 'gold') {
        var colors = [];
        familyLeaves.forEach(function (btn) {
          var c = btn.getAttribute('data-metal-color') || 'Yellow';
          if (colors.indexOf(c) === -1) colors.push(c);
        });
        colors.sort(function (a, b) {
          return COLOR_ORDER.indexOf(a) - COLOR_ORDER.indexOf(b);
        });

        colors.forEach(function (color) {
          var colorLeaves = familyLeaves.filter(function (btn) {
            return (btn.getAttribute('data-metal-color') || 'Yellow') === color;
          });
          colorLeaves.sort(function (a, b) {
            return karatNumber(a.getAttribute('data-metal-karat')) - karatNumber(b.getAttribute('data-metal-karat'));
          });

          var row = document.createElement('div');
          row.className = 'metal-color-row';

          var label = document.createElement('span');
          label.className = 'metal-color-label';
          label.appendChild(buildDot('metal-color-dot', COLOR_DOT[color] || COLOR_DOT.Yellow));
          label.appendChild(document.createTextNode(color));
          row.appendChild(label);

          var group = document.createElement('div');
          group.className = 'metal-karat-group';

          colorLeaves.forEach(function (btn) {
            btn.classList.add('metal-leaf-btn', 'metal-leaf-btn--labeled');
            if (!btn.querySelector('.metal-leaf-label')) {
              var karatLabel = document.createElement('span');
              karatLabel.className = 'metal-leaf-label';
              karatLabel.textContent = btn.getAttribute('data-metal-karat') || '';
              btn.appendChild(karatLabel);
            }
            group.appendChild(btn);
          });

          row.appendChild(group);
          panel.appendChild(row);
        });
      } else {
        var row = document.createElement('div');
        row.className = 'metal-family-row';
        familyLeaves.forEach(function (btn) {
          btn.classList.add('metal-leaf-btn', 'metal-leaf-btn--labeled');
          if (!btn.querySelector('.metal-leaf-label')) {
            var valueLabel = document.createElement('span');
            valueLabel.className = 'metal-leaf-label';
            valueLabel.textContent = btn.getAttribute('data-option-value') || '';
            btn.appendChild(valueLabel);
          }
          row.appendChild(btn);
        });
        panel.appendChild(row);
      }

      panelsWrap.appendChild(panel);
      panels.push(panel);
    });

    setActiveTab(tabs, panels, panelsWrap, initialFamily);

    tabsWrap.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-metal-tab]');
      if (!tab) return;

      var family = tab.getAttribute('data-metal-tab');
      setActiveTab(tabs, panels, panelsWrap, family);

      var panel = panelsWrap.querySelector('[data-metal-panel="' + family + '"]');
      if (!panel) return;

      var hasActiveLeaf = panel.querySelector('[data-option-value].active');
      if (!hasActiveLeaf) {
        var firstLeaf = panel.querySelector('[data-option-value]');
        if (firstLeaf) firstLeaf.click();
      }
    });

    panelsWrap.addEventListener('click', function (e) {
      var leaf = e.target.closest('[data-option-value]');
      if (!leaf) return;
      var family = leaf.getAttribute('data-metal-family') || 'other';
      setActiveTab(tabs, panels, panelsWrap, family);
    });

    mount.appendChild(tabsWrap);
    mount.appendChild(panelsWrap);

    source.style.display = 'none';
  }

  function initAll(scope) {
    scope.querySelectorAll('.variant-picker-item.has-metal-grouping').forEach(initItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
